import React from 'react'
import styles from './HomeCard.module.css'
import { useRouter } from '../../hooks'
import {
  getDetailPoster,
  generateDetailUrl
} from '../../utils'
import ContentDetail from '../Carousel/ContentDetail'

const HomeCard = ({ data }) => {
  const router = useRouter()

  if (!data) {
    return null
  }

  const handleClick = () => {
    router.history.push(generateDetailUrl(data))
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.cardTitle}>Available Now</div>
      <div className={styles.homeCard}>
        <div className={styles.pictureWrapper}>
          <img
            src={getDetailPoster(data)}
            alt='poster'
            className={styles.picture}
            onClick={handleClick}
          />
        </div>

        <div className={styles.itemDetail}>
          <ContentDetail
            item={data}
            handleClickDetail={handleClick}
          />
        </div>
      </div>
    </div>
  )
}

export default HomeCard
